import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	list(params) {
		return Repository.get(`/company/${company.value.id}/admin/exchange/list`, { params: params });
	},
	store(payload) {
		return Repository.post(`/company/${company.value.id}/admin/exchange`, payload).then((response) => {
			toast.success(`Tipos de cambio actualizados correctamente.`);
			return response;
		});
	}
}